import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { EChartsOption } from 'echarts';
import { BasicBarChartProps } from '../types';
import ChartWrapper from '../../../ChartWrapper';

function HorizontalBasicBar({
  data,
  height = 616,
  left = 120,
  right = 30,
  top = 10,
  bottom = 30,
  formatter,
  onLegendSelect = () => {},
}: BasicBarChartProps) {
  const option: EChartsOption = useMemo(() => {
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: (params: any) => {
          return `${params[0].name} <br/> <strong> ${params[0].marker} ${
            formatter ? formatter(params[0].value) : params[0].value
          }</strong>`;
        },
      },
      yAxis: {
        type: 'category',
        data: data.map(item => item.name),
        tooltip: {
          show: true,
        },
        axisLabel: {
          formatter: (value: string) => {
            return value.length > 15 ? `${value.slice(0, 15)}...` : value;
          },
          hideOverlap: true,
        },
        axisTick: {
          alignWithLabel: true,
        },
        inverse: true,
        boundaryGap: true,
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          formatter: formatter ? formatter : `{value}`,
        },
      },
      grid: {
        left,
        right,
        top,
        bottom,
      },
      series: [
        {
          data: data.map(item => ({
            value: item.value,
            itemStyle: {
              color: item.color || '#5484CC',
            },
          })),
          barMaxWidth: 30,
          type: 'bar',
        },
      ],
    } as EChartsOption;
  }, [data, left, right, top, bottom]);

  const events = useMemo(() => {
    return {
      legendselectchanged: (param: any, echarts: any) => {
        onLegendSelect(param.name);
      },
    };
  }, []);

  return (
    <ChartWrapper>
      <ReactECharts
        option={option}
        style={{ height, width: '100%' }}
        lazyUpdate
        notMerge
        onEvents={events}
      />
    </ChartWrapper>
  );
}

export default React.memo(HorizontalBasicBar);
